import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { uid } from "react-uid";
import HomePage from "../Pages/HomePage/HomePage";
import AuthSuccess from "../Pages/AuthSuccess/AuthSuccess";
import PageNotFound from "../Pages/PageNotFound/PageNotFound";
import AuthRoute from "./AuthRoute";
import PrivateRoute from "./PrivateRoute";
import { RouteList } from "./RouteList";
import { isEmpty } from "../utils/custom_funtions";
import PrintView from '../Pages/CreatePaper/PrintView';

const AppRoutes = () => {
  return (
    <Router>
      <Routes>-
        {/* Public Routes */}
        <Route path="/login" exact element={<HomePage />} />
        {/* Print Route */}
        <Route path="/createPaper/printView" element={<PrintView />} />
        {/* For wrong URl  */}
        <Route path="*" element={<PageNotFound />} /> 
        {/* Private routes */}
        <Route element={<PrivateRoute />}>
          
            {RouteList.map((route) => {
              return (
                <Route path="/" element={<AuthSuccess showMenu={route.showMenu} />} key={uid(route)}>
                <Route
                  path={route.path}
                  key={route.path}
                  exact
                  element={
                    isEmpty(route.role) ? (
                      route.element
                    ) : (
                      <AuthRoute allowedRoles={[route.role]} />
                    )
                  }
                >
                  {!isEmpty(route.role) &&
                    route.child.map((routeChild) => {
                      return (
                        <Route
                          index
                          key={routeChild.path}
                          path={routeChild.path}
                          exact
                          element={routeChild.element}
                        />
                      );
                    })}
                </Route>
                </Route>
              );
            })}
          <Route />
        </Route>
      </Routes>
    </Router>
  );
};

export default AppRoutes;
